// extracted by mini-css-extract-plugin
export var css1rvuyv0 = "index-module--css1rvuyv0--vKU-o";
export var cssfudml1 = "index-module--cssfudml1--gh-95";